export default "__VITE_ASSET__IEBB_PaS__";